import styled from 'styled-components';

interface DashboardInfoInterface {
  variant?: 'info' | 'warning';
}

const DashboardLayout = styled.section`
  padding: 1rem;
`;

const DashboardInfo = styled.article<DashboardInfoInterface>`
  background-color: ${({ theme, variant }) =>
    variant === 'warning'
      ? theme.palette.warning.light
      : theme.palette.primary.lighter};
  border-radius: 0.5rem;
  margin: 1rem 0;
  padding: 0.75rem;
`;

const DashboardInfoHeader = styled.h4`
  margin: 0;
`;

const DashboardInfoText = styled.p`
  margin: 0;
`;

export {
  DashboardLayout,
  DashboardInfo,
  DashboardInfoHeader,
  DashboardInfoText,
};
